export const formatSpecialty = (specialty: string) =>
  specialty.replace(/&/g, 'and').replace(/'/g, '');
